module.exports = __webpack_public_path__ + "static/media/img_near_logo.70811a94.jpg";